import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';
import EFVideo from '@/components/UI/EFVideo';

export default function CSection3() {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('xstream');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const fadeIn = (el: any) => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 750;
        const target = `.xstream_h5 .C_section3 ${el}`;

        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1,
            duration: layoutH / 10,
        });
        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        scene1.setTween(tween1);
        scene1.addTo(controller);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: layoutH / 10,
            triggerHook: 1,
            duration: layoutH / 10,
        });
        const tween2 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(controller);

        const scene3 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: (layoutH / 10) * 2,
            triggerHook: 0,
            duration: (layoutH / 10) * 8,
        });
        const tween3 = TweenMax.fromTo(target, 0.5, { opacity: 1 }, { opacity: 1 });
        scene3.setTween(tween3);
        scene3.addTo(controller);
    };

    useEffect(() => {
        fadeIn('.title');
        fadeIn('.desc');
    }, []);

    return (
        <div className={`C_section3 ${css.C_section3}`}>
            <div className="cover"></div>
            <div className="videoBox">
                <EFVideo
                    sources={['/media/x-stream/h5/04_fast.webm', '/media/x-stream/h5/04_fast.mp4']}
                    className="video_fast"
                    width="100%"
                    muted
                    autoPlay
                    loop
                    preload="auto"
                />
                <div className="textBox">
                    <p className="title">{t('section_4_title')}</p>
                    <p className="desc">{t('section_4_desc')}</p>
                </div>
            </div>
        </div>
    );
}
